var map = {
	"./pages/example-libs.js": 273,
	"./pages/example-mdx.mdx": 274,
	"./pages/example-styleguide-components-outside-styleguide.mdx": 275,
	"./pages/hello-world.js": 276,
	"./pages/index.js": 277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;